import { Component, OnInit } from "@angular/core";
import { Subscription, Subject } from "rxjs";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit {
  subscription: Subscription;
  contact_info: any;
  private ngUnsubscribe = new Subject();
  constructor() {}

  ngOnInit() {
    this.FetchData();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
    // this.subscription.unsubscribe();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  FetchData() {
    // debugger;
    let mData = localStorage.getItem("mainData");

    if (mData != null) {
      this.contact_info = JSON.parse(mData);
    }
    // console.log(this.contact_info, "Contact main Data");
  }
}
